import React, { FC } from 'react';
import PostComposerContentText from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentText';
import { PostComposerContentProps } from 'app/modules/posts/modules/post/components/composer/PostComposerContent';
import PostComposerContentMediaAttachments from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentMediaAttachemnts';
import { PseudoPostType } from 'constants/post';
import PostsConfig from 'app/config/posts';
import PostComposerContentLinkAppender from './PostComposerContentLinkAppender';

type Props = PostComposerContentProps;

const PostComposerContentThreads: FC<Props> = ({
  value,
  onChange,
  onTextEditorInit,
  onTranslationEditorInit,
  swapTextTranslation,
}) => {
  const pseudoType = value.pseudoType;

  return (
    <>
      <PostComposerContentText
        value={value}
        onChange={onChange}
        onTextEditorInit={onTextEditorInit}
        onTranslationEditorInit={onTranslationEditorInit}
        swapTextTranslation={swapTextTranslation}
      />
      {pseudoType && (
        <>
          {[PseudoPostType.Video, PseudoPostType.PhotoGallery].includes(
            pseudoType,
          ) && (
            <PostComposerContentMediaAttachments
              value={value}
              onChange={onChange}
              allowedFiles={
                PseudoPostType.Video === pseudoType ? ['video'] : ['image']
              }
              maxCount={
                [PseudoPostType.Photo, PseudoPostType.Video].includes(
                  pseudoType,
                )
                  ? PostsConfig.MIN_FILES_TO_ACCEPT
                  : PostsConfig.MAX_FILES_TO_ACCEPT
              }
            />
          )}
          <PostComposerContentLinkAppender
            value={value}
            onChange={onChange}
            withLinkFieldOverride
          />
        </>
      )}
    </>
  );
};

export default PostComposerContentThreads;
